export default __webpack_public_path__ + "static/media/BASE_TECNOLOGIA_RR_310_SMART_01.580147e9.jpg";